/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initialState = {
  claimAuditSelectScreenData: {},
  claimAuditDetailScreenData: {},
  labelerList: [],
  errorMsgCAudit: [],
  rebateProgram: [],
  speAuditType: [],
  claimAuditDetail: [],
  claimDetailList: [],
  claimActions: {},
  getNdcDetails: [],
  claimAuditDetails: [],
  claimAuditDescription: [],
  claimSearchList: [],
  claimAuditDetailObj: '',
  updateClearedResponse: [],
  pageCountwithDetails: '',
  rowSelectedInRedux: '',
  selectedAuditType: '',
  claimAuditPopupCount: '',
  exportAllOnDetailScr: {},
  freezeQuaterData: {},
  changesDataList: [],
   exportHandler: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CLAIM_AUDIT_SELECT_SCREEN_OBJ:
      return { ...state, claimAuditSelectScreenData: action.screenData };
    case actionTypes.SET_CLAIM_AUDIT_SELECT_SCREEN_OBJ:
      return { ...state, claimAuditSelectScreenData: action.payload };
    case actionTypes.GET_CLAIM_AUDIT_DETAIL_SCREEN_OBJ:
      return { ...state, claimAuditDetailScreenData: action.detailScreenData };
    case actionTypes.GET_ALL_LABELER:
      return { ...state, labelerList: action.payload };
    case actionTypes.GET_ERROR_MSG_FOR_CLAIM_AUDIT:
      return { ...state, errorMsgCAudit: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_DROPDOWN:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_SPECIFIC_AUDIT_TYPE_DROPDOWN:
      return { ...state, speAuditType: action.payload };
    case actionTypes.GET_CLAIM_AUDIT_DETAIL:
      return { ...state, claimAuditDetail: action.payload };
    // case actionTypes.GET_CLAIM_DETAILS:
    //   return { ...state, claimDetailList: action.payload };
    case actionTypes.CLAIM_CATEGORY_CD:
      return { ...state, claimCategoryCode: action.payload };
    case actionTypes.CLAIM_ACTIONS:
      return { ...state, claimActions: action.payload };
    // case actionTypes.GET_NDC_DETAILS:
    //   return { ...state, getNdcDetails: action.payload };
    case actionTypes.CLAIM_AUDIT_DETAILS:
      return { ...state, claimAuditDetails: action.payload };
    case actionTypes.CLAIM_AUDIT_DESCRIPTION:
      return { ...state, claimAuditDescription: action.payload };
    // case actionTypes.SEARCH_CLAIM_LIST:
    //   return { ...state, claimSearchList: action.payload };
    case actionTypes.CLAIM_AUDIT_DETAIL_TAB_DATA:
      return { ...state, claimAuditDetailObj: action.claimAuditDetailObj };
    case actionTypes.UPDATE_CLEARED_RESPONSE:
      return { ...state, updateClearedResponse: action.payload };
    case actionTypes.GET_PAGE_COUNT:
      return { ...state, pageCountwithDetails: action.payload };
    // case actionTypes.ROW_SELECTED:
    //   return { ...state, rowSelectedInRedux: action.payload };
    case actionTypes.SELECTED_AUDITTYPE:
      return { ...state, selectedAuditType: action.payload };
    case actionTypes.HANDLE_ERROR_MSG_CD:
      return { ...state, errorMessageInRedux: action.payload };
    case actionTypes.GET_CLAIM_AUDIT_POPUP_COUNT:
      return { ...state, claimAuditPopupCount: action.payload };
    case actionTypes.GET_EXPORT_ALL_DETAIL:
      return { ...state, exportAllOnDetailScr: action.payload };
    case actionTypes.ALL_CHANGES_CLAIM_AUDITS_DATA_LIST:
      return { ...state, changesDataList: action.changesDataList };
    case actionTypes.SET_EXPORT_HANDLER:
      return {...state, exportHandler: action.payload};
    // case actionTypes.GET_FREEZE_QUARTER_FOR_CLAIM_AUDIT:
    //   return { ...state, freezeQuaterData: action.payload };
    // case actionTypes.GET_PROVIDER_DETAILS: {
    //   return { ...state, providerDetails: action.providerDetails };
    // }
    default:
      return state;
  }
};

export default reducer;
